import { Injectable, computed, signal } from '@angular/core';

type AccessBlockReason = 'subscription-past-due';

interface AccessBlockState {
  reason: AccessBlockReason;
  title: string;
  message: string;
  contactIntro?: string;
  contactLabel?: string;
  contactOutro?: string;
  contactHref?: string;
  contactCtaLabel?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AccessBlockService {
  private readonly state = signal<AccessBlockState | null>(null);

  readonly blockState = computed(() => this.state());
  readonly isBlocked = computed(() => !!this.state());

  blockSubscriptionPastDue(isAdmin: boolean) {
    this.state.set({
      reason: 'subscription-past-due',
      title: 'Acesso temporariamente bloqueado',
      message: isAdmin
        ? 'O acesso ao sistema foi temporariamente suspenso devido ao atraso no pagamento da assinatura.\nPara reativar o serviço, realize o pagamento pendente.'
        : 'O acesso ao sistema está temporariamente indisponível no momento. Por favor, entre em contato com a sua liderança para mais informações. Agradecemos a compreensão.',
      contactIntro: isAdmin ? 'Em caso de dúvidas, entre em contato através do WhatsApp ' : undefined,
      contactLabel: isAdmin ? '(11) 99116-1833' : undefined,
      contactOutro: isAdmin ? ', estamos à disposição para ajudar.' : undefined,
      contactHref: isAdmin ? 'https://api.whatsapp.com/send?phone=5511991161833' : undefined,
      contactCtaLabel: isAdmin ? 'Entrar em contato' : undefined
    });
  }

  clear() {
    this.state.set(null);
  }
}